import { create } from 'zustand';

type BannerData = {
  icon: string;
  header: string;
  buttons?: Record<string, string>;
  selected?: string;
};

type BannerStore = {
  banner: BannerData | null;
  showBanner: (data: BannerData) => void;
  clearBanner: () => void;
};

export const useBannerStore = create<BannerStore>((set) => ({
  banner: null,
  showBanner: (data) => set({ banner: data }),
  clearBanner: () => set({ banner: null }),
}));
